import type { ConnectProblem } from "@mdbase-dev/connect";

export function connectProblemMessage(
  problem: Pick<ConnectProblem, "code" | "message" | "recovery">,
): string {
  if (problem.code === "connector_offline") {
    return "The computer holding this collection is offline.";
  }
  if (
    problem.code === "not_authorized" ||
    problem.code === "authorization_expired" ||
    problem.code === "application_declaration_mismatch"
  ) {
    return "This collection needs to be authorized again.";
  }
  if (problem.code === "insufficient_access") {
    return "This connection does not include the record access Tide needs.";
  }
  if (problem.code === "operation_outcome_unknown") {
    return "The save may have reached your collection. Reload Tide to recover the exact pending save before trying again.";
  }
  if (problem.recovery === "upgrade_collection") {
    return "This collection must be upgraded before Tide can change its records.";
  }
  if (problem.recovery === "repair_collection") {
    return "This collection needs repair before Tide can use it.";
  }
  return problem.message || "Tide could not reach this collection.";
}

export function connectProblemError(problem: ConnectProblem): Error {
  const error = new Error(connectProblemMessage(problem));
  Object.assign(error, { code: problem.code, problem });
  return error;
}

export function connectErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return "Tide could not reach this collection.";
}
